<template>
  <card-default>
    <div
      slot="title"
      class="card-heading">
      <div
        class="row clickable"
        clickable
        @click="toggleCollapse(stateKey)">
        <div class="col-10 h5">{{ title }}</div>
        <span
          v-if="cardCollapsed(stateKey)"
          class="col h4">-</span>
        <span
          v-else
          class="col h4">+</span>
      </div>
    </div>
    <div
      v-show="!cardCollapsed(stateKey)"
      slot="body"
      class="card-text">
      <slot/>
    </div>
  </card-default>
</template>

<script>
import CardDefault from '@/components/CardDefault'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CollapsibleCard',
  components: {
    CardDefault
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    stateKey: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      cardCollapsed: 'page/cardCollapsed'
    })
  },
  methods: {
    ...mapMutations('page', {
      toggleCollapse: 'TOGGLE_COLLAPSE'
    })
  }
}
</script>

<style scoped>
  .clickable {
    cursor: pointer;
  }
</style>
